import React from 'react';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import AutoRedirectSignIn from './AutoRedirectSignIn';
import {useToken} from '../hooks/useToken';

interface AuthenticationGuardProps {
  children: React.ReactNode;
}

const AuthenticationGuard: React.FC<AuthenticationGuardProps> = ({
  children,
}) => {
  const {isTokenReady, tokenError} = useToken();

  return (
    <>
      <AuthenticatedTemplate>
        {tokenError ? (
          <div className='alert alert-danger m-3'>
            <h4>Authentication Error</h4>
            <p>{tokenError}</p>
            <p>
              Please try refreshing the page or contact support if the problem
              persists.
            </p>
          </div>
        ) : isTokenReady ? (
          children
        ) : (
          <div
            className='d-flex justify-content-center align-items-center'
            style={{minHeight: '200px'}}>
            <div className='text-center'>
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
              <p className='mt-2'>Initializing authentication...</p>
            </div>
          </div>
        )}
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <AutoRedirectSignIn />
      </UnauthenticatedTemplate>
    </>
  );
};

export default AuthenticationGuard;
